module.exports = __webpack_public_path__ + "img/Web-Lady-Gulya-Tom-van-Oossanen-83314.jpg";